import { AddIcon } from '@approvalmax/ui';
import { Button, Flex, Popup, Text } from '@approvalmax/ui/src/components';
import random from 'lodash/random';
import { memo } from 'react';
import Skeleton from 'react-loading-skeleton';

import { useKycData } from '../../../../../resources/hooks/useKycData';
import { useToggleAddPersonPopup } from '../AddPersonPopup/AddPersonPopup.hooks';
import { Notice } from '../Notice/Notice';
import { OwnershipExplanationPopup } from '../OwnershipExplanationPopup/OwnershipExplanationPopup';
import { useOwnershipExplanationPopup } from '../OwnershipExplanationPopup/OwnershipExplanationPopup.hooks';
import { PersonsTable } from '../PersonsTable/PersonsTable';
import { messages } from './StepForm.messages';

export const StepForm = memo(() => {
    const { openAddPersonPopup } = useToggleAddPersonPopup();
    const { data } = useKycData();
    const { openOwnershipExplanationPopup, onOpenOwnershipExplanationPopup, oToggleOwnershipExplanationPopup } =
        useOwnershipExplanationPopup();

    return (
        <>
            <Text font='label' fontSize='medium' fontWeight='regular'>
                {messages.pleaseProvideDetails({
                    companyName: (
                        <b>
                            {data?.data?.businessInformation?.companyName ?? (
                                <Skeleton inline width={random(50, 100)} />
                            )}
                        </b>
                    ),
                })}
            </Text>

            <Text font='label' fontSize='medium'>
                {messages.additionallyPleaseProvide}

                <div>
                    <Button
                        noPadding
                        noUppercase
                        color='blue100'
                        fontWeight='regular'
                        variant='text'
                        onClick={onOpenOwnershipExplanationPopup}
                    >
                        {messages.learnMore}
                    </Button>
                </div>
            </Text>

            <PersonsTable />

            <Notice />

            <Flex justifyContent='end'>
                <Button
                    data-qa='add-person-button'
                    color='blue10'
                    size='small'
                    startIcon={<AddIcon />}
                    onClick={openAddPersonPopup}
                >
                    {messages.addPerson}
                </Button>
            </Flex>

            <Popup size='small' open={openOwnershipExplanationPopup} onToggle={oToggleOwnershipExplanationPopup}>
                <OwnershipExplanationPopup />
            </Popup>
        </>
    );
});

StepForm.displayName = 'StepForm';
